<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useLocale } from '@/plugins/translation';

const props = withDefaults(
  defineProps<{
    top?: string;
    left?: string;
    goBack?: () => void;
  }>(),
  {
    top: '80px',
    left: '16px',
  },
);

const router = useRouter();
const { t, l } = useLocale();

const handleBack = () => {
  if (props.goBack) {
    props.goBack();
  } else {
    router.push('/games');
  }
};
</script>

<template>
  <v-btn
    icon="fa:fas fa-chevron-left"
    variant="text"
    color="white"
    size="small"
    :style="{ position: 'fixed', top: props.top, left: props.left, zIndex: 11 }"
    @click="handleBack"
    :aria-label="t(l.label_go_back)"
  />
</template>

<style scoped lang="scss"></style>
